import { __spreadArray } from "tslib";
import { createTheme } from '@mui/material/styles';
var defaultShadows = createTheme().shadows;
function replaceElementsByIndices(array, indices, newValue) {
    var updatedArray = __spreadArray([], array, true);
    indices.forEach(function (index) {
        updatedArray[index] = newValue;
    });
    return updatedArray;
}
// 1 - default for Card
// 4 - default for AppBar
// 5 - default for DataGridPro
var indicesToUpdate = [1, 4, 5];
var customShadow = '0px 5px 15px 0px rgba(0, 0, 0, 0.10)'; // from Energy Savings mockup
var updatedShadows = replaceElementsByIndices(defaultShadows, indicesToUpdate, customShadow);
export var shadowsOptions = {
    shadows: updatedShadows,
};
/* @info */
// Default MUI theme values: https://mui.com/material-ui/customization/default-theme/
// there are default 25 shadows in the default theme
// and we can quickly find which default shadow is used fo component (copy from devtools and find here)
